import { RefObject } from 'react';

const isRefObject = (value: unknown): value is RefObject<Element | null> =>
  typeof value === 'object' && value !== null && 'current' in value;

export const getRefElement = <T>(
  element?: RefObject<Element | null> | T
): Element | T | undefined | null => {
  if (isRefObject(element)) {
    return element.current;
  }

  return element;
};
